import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  fullWidth = false,
  className = ''
}) => {
  const buttonClasses = `
    flex flex-row items-center justify-center h-[52px] p-4 rounded-lg
     font-semibold text-base leading-6 text-white
    transition-colors cursor-pointer
    ${disabled 
      ? 'bg-zinc-400 cursor-not-allowed' 
      : 'bg-zinc-700 hover:bg-zinc-950'
    }
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `.trim();

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
    >
      {children}
    </button>
  );
};

export default Button;